import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { useAuth0 } from '../react-auth0-spa';
import { getPermissions } from '../utils/user';

const PrivateRoute = ({
  component: Component,
  path,
  setSelectedLink,
  selectedLink,
  permissions: routePermissions = [],
  ...rest
}) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const permissions = getPermissions();

  useEffect(() => {
    const fn = async () => {
      if (!isAuthenticated) {
        await loginWithRedirect({
          appState: { targetUrl: path },
        });
      }
    };
    fn();
  }, [isAuthenticated, loginWithRedirect, path]);

  const render = (props) =>
    isAuthenticated === true ? (
      <Component
        setSelectedLink={setSelectedLink}
        selectedLink={selectedLink}
        {...props}
      />
    ) : null;

  let isAllowed = false;

  // If permissions array is empty than no permission is required to access it
  if (!routePermissions.length) {
    isAllowed = true;
  } else {
    routePermissions.forEach((permission) => {
      if (permissions.includes(permission)) {
        isAllowed = true;
      }
    });
  }

  return isAllowed ? (
    <Route path={path} render={render} {...rest} />
  ) : (
    <Redirect to='/' />
  );
};

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.object,
  ]).isRequired,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
  setSelectedLink: PropTypes.func.isRequired,
  selectedLink: PropTypes.string.isRequired,
  permissions: PropTypes.array,
};

export default PrivateRoute;
